export default "__VITE_ASSET__BDD2tGH7__"